import React from 'react'
import classNames from 'classnames'

import css from './checkbox.scss'

class Checkbox extends React.Component {
  static defaultProps = {
    checked: false,
    disabled: false,
  }

  render() {
    const { checked, onChange, disabled, className, ...rest } = this.props

    const checkboxClasses = classNames(css.customCheckbox, className, {
      [css.checked]: checked,
      [css.disabled]: disabled,
    })

    return (
      <div className={css.checkboxWrapper}>
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className={css.hiddenCheckbox}
          {...rest}
        />
        <div className={checkboxClasses}>
          {checked && (
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={css.checkIcon}
            >
              <path
                d="M6.75 11.625L3.375 8.25L2.25 9.375L6.75 13.875L15.75 4.875L14.625 3.75L6.75 11.625Z"
                fill="currentColor"
              />
            </svg>
          )}
        </div>
      </div>
    )
  }
}

export default Checkbox
